import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ARTICLES_VIEW } from '../../../router/routes';
import { route } from '../../../services/utils';
import Article from '../../../interfaces/article';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import css from '../index.module.css';

interface Props {
  article: Article;
}

export default function ArticleItem({ article }: Props) {
  const { t } = useTranslation();

  return (
    <div data-name={`article-item`} className={css['article']}>
      <h3>{article.title}</h3>
      <p className={css['date']}>{article.created_at}</p>
      <p>{article.description}</p>
      <Link
        to={route(ARTICLES_VIEW, { id: article.id })}
        className={css['show-more']}
      >
        <span>{t('common.read_more')}</span>
        <FontAwesomeIcon icon={faChevronRight} />
      </Link>
    </div>
  );
}
